export class IdleWarningModalTemplate {
  public static getHtml(): string {
    return `
      <div class="idle-session-modal" role="dialog" aria-modal="true" aria-labelledby="idle-session-title">
        <div class="idle-session-modal__header">
          <div class="idle-session-modal__title-wrap">
            <svg
              class="idle-session-modal__icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="#1D5FD3"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm1 15h-2v-6h2v6zm0-8h-2V5h2v2z"/>
            </svg>
            <h2 id="idle-session-title" class="idle-session-modal__title">Session Expiring</h2>
          </div>
        </div>
        <div class="idle-session-modal__body">
          <p>You've been inactive for a while. For security reasons, your session will expire in <strong data-idle-minutes>15 minutes</strong>.</p>
          <p>Select Continue to keep working, or you'll be signed out automatically.</p>
        </div>
        <div class="idle-session-modal__actions">
          <button type="button" class="idle-session-btn idle-session-btn--secondary" data-idle-action="logout">Logout</button>
          <button type="button" class="idle-session-btn idle-session-btn--primary" data-idle-action="continue">Continue</button>
        </div>
      </div>
    `;
  }
}
